export default "__VITE_ASSET__B5_LHm7S__"